module.exports = __webpack_public_path__ + "img/cx_teste_dengue_duo.26d02a75.webp";